import { Controller } from "@hotwired/stimulus";

type Labels = { master: string; player: string; toggle_title: string };

// Markup outside the app, such as Foundry's, carries no labels and reads these.
const DEFAULT_LABELS: Labels = {
	master: "Ver mapa COM legenda",
	player: "Ver mapa SEM legenda",
	toggle_title: "Alterna entre a versão do Mestre e do Jogador",
};

// Connects to data-controller="chapter-map"
// Chapter Markdown writes this markup, and Foundry exports it, so the identifier, target, class and data attribute names are fixed.
// The application layout's <body> carries the labels, since no mount can pass any.
export default class extends Controller {
	static targets = ["image"];
	static classes = ["button"];
	declare readonly imageTarget: HTMLImageElement;
	declare readonly buttonClasses: string[];
	button?: HTMLButtonElement;

	get labels(): Labels {
		const json = this.element.closest<HTMLElement>("[data-chapter-map-labels]")?.dataset.chapterMapLabels;
		return json ? { ...DEFAULT_LABELS, ...JSON.parse(json) } : DEFAULT_LABELS;
	}

	// chapter maps should always have src with the master version set.
	connect() {
		if (this.imageTarget.dataset.masterVersion) {
			this.imageTarget.src = this.imageTarget.dataset.masterVersion;
		} else {
			this.imageTarget.dataset.masterVersion = this.imageTarget.src;
		}

		// Remove all buttons from this element, in case user is returning and disconnect wasn't properly called
		for (const button of this.element.querySelectorAll("button")) button.remove();

		this.createToggleButton();
	}

	disconnect() {
		this.button?.remove();
	}

	createToggleButton() {
		this.button = document.createElement("button");
		this.button.textContent = this.labels.player;
		this.button.title = this.labels.toggle_title;
		this.button.classList.add(...this.buttonClasses);
		this.button.addEventListener("click", this.toggleImage.bind(this));

		this.element.appendChild(this.button);
	}

	// The resolved property: a relative src attribute never equals the absolute master version connect() stores.
	isOnMasterVersion() {
		return this.imageTarget.src === this.imageTarget.dataset.masterVersion;
	}

	toggleImage() {
		if (!this.button) return;
		if (this.isOnMasterVersion()) {
			this.imageTarget.src = this.imageTarget.dataset.playerVersion ?? "";
			this.button.textContent = this.labels.master;
		} else {
			this.imageTarget.src = this.imageTarget.dataset.masterVersion ?? "";
			this.button.textContent = this.labels.player;
		}
	}
}
